/** @jsx jsx */
import { FC, Fragment } from 'react';
import { jsx } from '@emotion/core';
import SimpleMessagePage from 'components/SimpleMessagePage';
import {
  useMarkdownTranslate,
  useMarkdownMultilineTranslate,
} from 'hooks/useTranslate/useTranslate';
import CancelButton from 'features/CancelButton';

const LoyaltyNumberError: FC = () => {
  const tMd = useMarkdownTranslate();
  const tMdMultiline = useMarkdownMultilineTranslate();

  const content = (
    <Fragment>
      <div>{tMdMultiline(`home.loyaltyNumber.error.message`)}</div>
    </Fragment>
  );

  return (
    <SimpleMessagePage
      headerTitle={tMd('home.loyaltyNumber.error.title')}
      message={content}
    >
      <CancelButton />
    </SimpleMessagePage>
  );
};

export default LoyaltyNumberError;
